import { render, staticRenderFns } from "./ClientRisksTabComponent.vue?vue&type=template&id=43cf36be&scoped=true&"
import script from "./ClientRisksTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientRisksTabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClientRisksTabComponent.vue?vue&type=style&index=0&id=43cf36be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf36be",
  null
  
)

export default component.exports